import Reflux from "reflux";
import _ from "lodash";
import Immutable from "immutable";
import DomainActions from "../actions/DomainActions";
import DomainSettingsActions from "../actions/DomainSettingsActions";
import UIActions from "../actions/UIActions";
import AppConstants from "../constants/AppConstants";
import UserService from "../service/UserService";
import { getUserId } from "../hooks/query/useAccount";
import { updateDomainInCache } from "../hooks/query/useUserDomains";
import APIError from "../service/APIError";
import ErrorUtils from "../utils/ErrorUtils";

var initialState = {
  tab: "redirects",
  working: false,
  optionTabEnabled: false,

  domainPanel: {},

  redirectsPanel: {
    addForm: {
      error: false,
      saving: false,
      fromURL: "",
      toURL: "",
    },
  },

  domain: {
    changed: false,
    original: {},
    current: {},
  },

  redirects: {
    list: [],
    available: false,
    error: false,
  },
};

var DomainSettingsStore = Reflux.createStore({
  storeName: 'DomainSettingsStore',
  listenables: [DomainSettingsActions],

  init() {
    this.listenToMany({
      loadRedirects: DomainActions.loadRedirects,
      deleteRedirect: DomainActions.deleteRedirect,
      addRedirect: DomainActions.addRedirect,
    });

    this.state = Immutable.fromJS(initialState);
  },

  onEditSettings(domain) {
    this.state = Immutable.fromJS(initialState);

    let domainImm = Immutable.fromJS(domain);

    this.state = this.state.setIn(["domain", "original"], domainImm);
    this.state = this.state.setIn(["domain", "current"], domainImm);

    if (domainImm.get("parent_site_id") != null) {
      this.state = this.state.set("optionTabEnabled", false);
      this.state = this.state.set("tab", "redirects");
    } else {
      let wwwRequired = domainImm.get("www_required", false) == 1;
      if (wwwRequired) {
        this.state = this.state.set("optionTabEnabled", true);
        this.state = this.state.set("tab", "domain");
      }
    }

    this._loadRedirects();

    this.trigger(this.state);
  },

  onUpdateProperty(propChange) {
    var domain = this.state.getIn(["domain", "current"]);
    var original = this.state.getIn(["domain", "original"]);

    domain = domain.set(propChange.name, propChange.value);

    this.state = this.state.setIn(["domain", "current"], domain);

    this.state = this.state.setIn(["domain", "changed"], !Immutable.is(domain, original));

    this.trigger(this.state);
  },

  onChangeTab(tab) {
    var currentTab = this.state.get("tab");

    if (currentTab != tab && "redirects" == tab) {
      this._loadRedirects();
    }

    this.state = this.state.set("tab", tab);

    this.trigger(this.state);
  },

  _loadRedirects() {
    var domain = this.state.getIn(["domain", "original"]);

    var redirectsAvailable = this.state.getIn(["redirects", "available"]);

    if (domain && !redirectsAvailable) {
      this.state = this.state.setIn(["redirects", "available"], false);
      this.state = this.state.setIn(["redirects", "error"], false);

      DomainActions.loadRedirects({
        userId: getUserId(),
        domainId: domain.get("site_id"),
      });

      this.trigger(this.state);
    }
  },

  onSaveSettings() {
    this.state = this.state.set("working", true);

    var domain = this.state.getIn(["domain", "current"]);
    var siteId = domain.get("site_id");

    UserService.updateDomain(getUserId(), siteId, domain.toJS())
      .then(this._onSaveComplete.bind(this))
      .catch(this._onActionFailed.bind(this));
  },

  onUndoSettingsChange() {
    var original = this.state.getIn(["domain", "original"]);

    this.state = this.state.setIn(["domain", "current"], original);
    this.state = this.state.setIn(["domain", "changed"], false);

    this.trigger(this.state);
  },

  _onSaveComplete(data) {
    this.state = this.state.set("working", false);

    var domain = data.domain;

    var domainImm = Immutable.fromJS(domain);

    this.state = this.state.setIn(["domain", "original"], domainImm);
    this.state = this.state.setIn(["domain", "current"], domainImm);
    this.state = this.state.setIn(["domain", "changed"], false);

    this.trigger(this.state);

    DomainActions.domainSettingsUpdated(domain);

    updateDomainInCache(domain.site_id, (d) => ({ ...d, ..._.pick(domain, ["www_required"]) }));
  },

  _onActionFailed(err) {
    this.state = this.state.set("working", false);

    if (APIError.handle(err)) {
      return;
    }

    var error = ErrorUtils.getFormattedError(err);

    console.error(error);

    UIActions.modalOpen(AppConstants.MODAL_ACTION_CONFIRM, {
      title: "Update Failed",
      message: error.message,
      confirmBtn: "Ok",
      alertMode: true,
    });

    this.trigger(this.state);
  },

  onLoadRedirectsComplete(data) {
    this.state = this.state.setIn(["redirects", "available"], true);
    this.state = this.state.setIn(["redirects", "error"], false);

    this.state = this.state.setIn(["redirects", "list"], Immutable.fromJS(data.redirects));

    this.trigger(this.state);
  },

  onLoadRedirectsFail(err) {
    if (APIError.handle(err)) {
      return;
    }

    var error = ErrorUtils.getFormattedError(err);

    this.state = this.state.setIn(["redirects", "available"], false);
    this.state = this.state.setIn(["redirects", "error"], error);

    this.trigger(this.state);
  },

  onDeleteRedirectFail(err) {
    this._onActionFailed(err);
  },

  onDeleteRedirectComplete(data) {
    var list = this.state.getIn(["redirects", "list"]);

    var index = list.findIndex(function (redirect) {
      return redirect.get("id") == data.redirect_id;
    });

    if (index >= 0) {
      this.state = this.state.deleteIn(["redirects", "list", index]);
    }

    this.trigger(this.state);
  },

  onAddRedirectFail(err) {
    if (APIError.handle(err)) {
      return;
    }

    var error = ErrorUtils.getFormattedError(err);

    if (ErrorUtils.hasFieldErrors(error)) {
      let fromError = ErrorUtils.getFieldErrorMessage(error, "from_url");
      let toError = ErrorUtils.getFieldErrorMessage(error, "to_url");

      if (fromError) {
        switch (fromError.message) {
          case "From Exists":
            error.message = "The Old Page already exists in the list.";
            break;
          case "Invalid From":
            error.message = "The Old Page is the same as a Redirected To location.";
            break;
        }
      } else if (toError) {
        switch (toError.message) {
          case "Invalid To":
            error.message = "You cannot redirect to an Old Page.";
            break;
          case "To Equals From":
            error.message = "The Old Page cannot be the same as the Redirected To location";
            break;
        }
      }
    }

    this.state = this.state.setIn(["redirectsPanel", "addForm", "error"], Immutable.fromJS(error));
    this.state = this.state.setIn(["redirectsPanel", "addForm", "saving"], false);

    this.trigger(this.state);
  },

  onAddRedirectComplete(data) {
    var redirect = _.get(data, "redirect");

    var list = this.state.getIn(["redirects", "list"]);

    list = list.unshift(Immutable.fromJS(redirect));

    this.state = this.state.setIn(["redirects", "list"], list);

    this.state = this.state.setIn(
      ["redirectsPanel", "addForm"],
      Immutable.fromJS(initialState.redirectsPanel.addForm)
    );

    this.trigger(this.state);
  },

  onUpdateAddForm(update) {
    this.state = this.state.mergeIn(["redirectsPanel", "addForm"], update);
    this.trigger(this.state);
  },

  onSubmitAddForm() {
    var domain = this.state.getIn(["domain", "current"]);
    var form = this.state.getIn(["redirectsPanel", "addForm"]);

    var redirect = {
      from_url: form.get("fromURL"),
      to_url: form.get("toURL"),
    };

    DomainActions.addRedirect({
      userId: getUserId(),
      domainId: domain.get("site_id"),
      redirect: redirect,
    });

    var actionState = {
      error: false,
      saving: true,
    };

    this.state = this.state.mergeIn(["redirectsPanel", "addForm"], Immutable.fromJS(actionState));
  },

  onRedirectDelete(/** Immutable.Map **/ redirect) {
    var domain = this.state.getIn(["domain", "current"]);

    var data = {
      userId: getUserId(),
      domainId: domain.get("site_id"),
      redirectId: redirect.get("id"),
    };

    DomainActions.deleteRedirect(data);
  },

  getState() {
    return this.state;
  },
});

export default DomainSettingsStore;
